<div class="sz-whats-new" [class.is-open]="open()" [attr.aria-hidden]="!open()">
  <div class="sz-whats-new__scrim" (click)="onScrimClick()"></div>
  <div class="sz-whats-new__card" role="dialog" aria-modal="true">
    <div class="sz-whats-new__title">{{ title() }}</div>

    <ul class="sz-whats-new__list">
      @for (change of changes(); track $index) {
        <li class="sz-whats-new__item">
          <span class="sz-whats-new__icon"><sz-icon [name]="iconFor(change.icon)" [size]="22" /></span>
          <span class="sz-whats-new__text">{{ change.text }}</span>
        </li>
      }
    </ul>

    <sz-button variant="primary" [fullWidth]="true" (click)="onClose()">{{ ctaLabel() }}</sz-button>
  </div>
</div>
